var $bee71eebeb71e510$exports = {};
// Elemen untuk menampilkan leaderboard
const $bee71eebeb71e510$var$leaderboardBody = document.getElementById('leaderboard-body');
const $bee71eebeb71e510$var$sortButton = document.getElementById('sort-button'); // Tombol untuk mengurutkan leaderboard
const $bee71eebeb71e510$var$filterInput = document.getElementById('filter-input'); // Input untuk filter leaderboard
// Fungsi untuk memuat leaderboard dari API eksternal atau server
const $bee71eebeb71e510$var$loadLeaderboard = async ()=>{
    try {
        // Menampilkan indikator loading sebelum data dimuat
        $bee71eebeb71e510$var$leaderboardBody.innerHTML = '<tr><td colspan="3">Memuat data...</td></tr>';
        // Ambil data leaderboard dari API (misalnya menggunakan fetch)
        const response = await fetch('/api/getLeaderboard'); // Ganti dengan URL API Anda
        const leaderboardData = await response.json(); // Mengambil data leaderboard
        if (leaderboardData.length === 0) {
            $bee71eebeb71e510$var$leaderboardBody.innerHTML = '<tr><td colspan="3">Papan peringkat kosong.</td></tr>';
            return;
        }
        // Menambahkan data leaderboard ke dalam tabel
        $bee71eebeb71e510$var$leaderboardBody.innerHTML = ''; // Bersihkan konten tabel terlebih dahulu
        leaderboardData.forEach((entry, index)=>{
            const row = document.createElement('tr');
            row.innerHTML = `
        <td>${index + 1}</td>
        <td>${entry.name}</td>
        <td>${entry.points}</td>
      `;
            $bee71eebeb71e510$var$leaderboardBody.appendChild(row);
        });
    } catch (error) {
        console.error('Error loading leaderboard:', error);
        $bee71eebeb71e510$var$leaderboardBody.innerHTML = '<tr><td colspan="3">Gagal memuat data leaderboard. Coba lagi nanti.</td></tr>';
    }
};
// Fungsi untuk mengurutkan leaderboard berdasarkan poin
const $bee71eebeb71e510$var$sortLeaderboard = ()=>{
    const rows = Array.from($bee71eebeb71e510$var$leaderboardBody.querySelectorAll('tr'));
    const sortedRows = rows.slice(1).sort((a, b)=>{
        const pointsA = parseInt(a.cells[2].textContent);
        const pointsB = parseInt(b.cells[2].textContent);
        return pointsB - pointsA; // Urutkan dari poin tertinggi ke terendah
    });
    // Menambahkan kembali baris yang sudah diurutkan
    $bee71eebeb71e510$var$leaderboardBody.innerHTML = '';
    sortedRows.forEach((row)=>$bee71eebeb71e510$var$leaderboardBody.appendChild(row));
};
// Fungsi untuk memfilter leaderboard berdasarkan input
const $bee71eebeb71e510$var$filterLeaderboard = ()=>{
    const filterText = $bee71eebeb71e510$var$filterInput.value.toLowerCase();
    const rows = Array.from($bee71eebeb71e510$var$leaderboardBody.querySelectorAll('tr'));
    rows.forEach((row)=>{
        const nameCell = row.cells[1];
        if (nameCell) {
            const name = nameCell.textContent.toLowerCase();
            row.style.display = name.includes(filterText) ? '' : 'none';
        }
    });
};
// Mengikat event listener untuk tombol urutkan
$bee71eebeb71e510$var$sortButton?.addEventListener('click', $bee71eebeb71e510$var$sortLeaderboard);
// Mengikat event listener untuk input filter
$bee71eebeb71e510$var$filterInput?.addEventListener('input', $bee71eebeb71e510$var$filterLeaderboard);
// Memuat leaderboard saat halaman dimuat
window.addEventListener('load', $bee71eebeb71e510$var$loadLeaderboard);


//# sourceMappingURL=leaderboard.ddfc0137.js.map
